<template>

  <el-dialog :show-close="true" title="上传日志" :visible="dialogVisible" width="50%" @close="bntClick(null)">

    <el-date-picker
        v-model="date"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
    </el-date-picker>

    <div slot="footer" class="dialog-footer">
      <el-button @click="bntClick(null)">取消</el-button>
      <el-button type="primary" @click="bntClick(date)">推送命令</el-button>
    </div>
  </el-dialog>

</template>

<script>

///上传日志时间选择框
import dateUtils from "@/utils/dateUtils";

export default {
  name: "UpLoadLogFileDialog",
  //完整接收props参数
  props: {
    dialogVisible: {
      type: Boolean,
      default: false //默认值
      // required:true //是必要的
    },
  },
  data() {
    return {
      date: [dateUtils.getCurrentDate(), dateUtils.getCurrentDate()]
    }
  },
  methods: {
    bntClick(value) {
      this.$emit('upLoadLogFileClick', value)
    }
  }
}
</script>

<style scoped>

</style>